import { createRouter, createWebHistory } from 'vue-router'
import WelcomePage from '@/components/WelcomePage.vue' // Pfad zu deiner WelcomePage
import UserProfile from '@/components/UserProfile.vue'
import UserDashboard from '@/components/UserDashboard.vue'

const routes = [
  {
    path: '/',
    name: 'WelcomePage',
    component: WelcomePage
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile,
    props: route => ({ user: route.params.user })
  },
  {
    path: '/userDashboard',
    name: 'UserDashboard',
    component: UserDashboard,
    props: route => ({ user: route.params.user })
  }
  // Weitere Routen hier hinzufügen
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
